module.exports = __webpack_public_path__ + "media/brands/qoros-356b2d4b.png";